import { BaseService } from 'core/services';
import VendorsRouteService from './VendorsRouteService';

class VendorsService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new VendorsRouteService());
    }
}

export default VendorsService;
